import React, { useState } from 'react';
import { Table, Input, Typography, Button } from 'antd';
import { useMovimientos } from '../../context/movimientosContext.js';

const { Title } = Typography;

export const ClienteSelector = ({ usuarios }) => {
  const { setSelectedCliente } = useMovimientos();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            size="small"
          >
            Buscar
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small">
            Resetear
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <span style={{ color: filtered ? '#1890ff' : undefined }}>🔍</span>
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) =>
      searchedColumn === dataIndex ? (
        <span style={{ backgroundColor: '#ffc069', padding: '0 5px' }}>{text}</span>
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Usuario',
      dataIndex: 'usuario',
      key: 'usuario',
      ...getColumnSearchProps('usuario'),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      ...getColumnSearchProps('email'),
    },
    {
      title: 'CUIT',
      dataIndex: 'cuit',
      key: 'cuit',
      ...getColumnSearchProps('cuit'),
    },
  ];

  const rowSelection = {
    type: 'radio',
    onChange: (_, selectedRows) => {
      setSelectedCliente(selectedRows[0]);
    },
  };

  return (
    <>
      <Title level={4}>Seleccionar Cliente</Title>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={usuarios}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
      />
    </>
  );
};
